import { AuthPage } from '../../../src/components/pages/auth';

export const ConfirmEmail = () => {
  return <AuthPage type='confirmEmail' />;
};
